import {Injectable}       from '@angular/core';
import {EditContractPage} from "../edit-contract/edit-contract.page";
import {ModalController}  from "@ionic/angular";
import {PermissionType}   from "../API.service";

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    constructor(private modalController: ModalController) {


    }

    async contractEdit(contractId: any, owner = undefined, client = undefined) {

        let EditContractPageProps: any = {}
        EditContractPageProps.contractId = contractId;
        if (owner?.permessions === PermissionType.COMMERCIAL) {
            EditContractPageProps.commerciale = owner;
        }
        if (client) {
            EditContractPageProps.client = client;
        }
        const modal = await this.modalController.create({
            component: EditContractPage,
            componentProps: EditContractPageProps,
            cssClass: 'custom-modal',
        });
        await modal.present();
        return modal.onWillDismiss()


    }
}
